module.exports = __webpack_public_path__ + "static/media/oumar.02467954.jpg";